import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FeahterIconModule } from 'src/app/core/feather-icon/feather-icon.module';
import { NgbDatepickerModule, NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgApexchartsModule } from "ng-apexcharts";
import { ChartsModule } from 'ng2-charts';
import { ManufacturerService } from 'src/app/services/manufacturer.service';

import { TranslateModule } from '@ngx-translate/core';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSelectFilterModule } from 'mat-select-filter';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTreeModule } from '@angular/material/tree';
import { MatRadioModule } from '@angular/material/radio';
import { ArchwizardModule } from 'angular-archwizard';
import { FarmerService } from 'src/app/services/farmer.service';
import { DivisionService } from 'src/app/services/division.service';
import { CashBookingService } from 'src/app/services/cashbooking.service';
import { BookingService } from 'src/app/services/booking.service';
import { ProductService } from 'src/app/services/product.service';
import { EefarmerbookingpopupComponent } from './eefarmerbookingpopup.component';

const routes: Routes = [
  {
    path: '',
    component: EefarmerbookingpopupComponent
  }, 
]

@NgModule({
  declarations: [ EefarmerbookingpopupComponent],
  providers: [
    FarmerService,
    DivisionService,
    CashBookingService,
    BookingService,
    ProductService,
],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FormsModule,
    FeahterIconModule,
    NgbDropdownModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,    
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatInputModule,
    MatFormFieldModule,
    NgApexchartsModule,
    ChartsModule,
    MatSelectModule, 
    MatSelectFilterModule,
    NgxDatatableModule,
    MatTabsModule,
    MatTreeModule,
    ArchwizardModule,
    NgbModule
  ],
 

})
export class eefarmerbookingpopupModule { }
